const cartBtn = document.querySelector('.quicknav__cart')
const cartBtnTotal = document.querySelector('.quicknav__cart span')

const AddToCart = {
  init(target) {
    if (target) {
      const form = target

      form.addEventListener('submit', (e) => {
        e.preventDefault()
        this.submit(form)
      })

      if (cartBtnTotal?.innerHTML === '0') {
        cartBtn.classList.add('quicknav__cart--empty')
      }
    }
  },

  async submit(form) {
    const buttonCounter = form.querySelectorAll('.button__counter')
    const button = form.querySelector('button[type=submit]')
    const callout = form.querySelectorAll('.callout')
    const data = new FormData(form)
    const action = form.getAttribute('action')
    const formMethod = form.getAttribute('method')

    if (callout) {
      callout.forEach((el) => el.remove())
    }

    if (button) {
      button.disabled = true
      button.classList.remove('button--added-cart')
      button.classList.add('button--loading')
    }

    buttonCounter.forEach((counterButton) => {
      counterButton.addEventListener('click', () => {
        button.classList.remove('button--added-cart')
      })
    })

    fetch(action, {
      method: formMethod,
      body: data,
    })
      .then((res) => {
        return res.status === 409 ? res : res.json()
      })
      .then((response) => {
        if (response.status === 409) {
          button.classList.remove('button--loading')
          button.classList.add('button--disabled')
          button.disabled = true
          this.renderMessage(form, 'Vara ekki til á lager', 'error')
          return
        }
        if (response.success) {
          // this.renderMessage(form, response.message, "success");
          if (cartBtnTotal && response.orderInfo.TotalQuantity) {
            cartBtnTotal.innerHTML = response.orderInfo.TotalQuantity

            if (response.orderInfo.TotalQuantity !== '0') {
              cartBtn.classList.remove('quicknav__cart--empty')
            } else {
              cartBtn.classList.add('quicknav__cart--empty')
            }
          }
          if (button) {
            button.classList.add('button--added-cart')
            button.classList.remove('button--loading')
          }
          setTimeout(() => {
            if (button) {
              button.classList.remove('button--added-cart')
            }
          }, 2000)
          form.reset()
        } else {
          this.renderMessage(form, 'Eitthvað fór úrskeiðis', 'error')
        }
        setTimeout(() => {
          if (button) {
            button.classList.remove('button--loading')
            button.disabled = false
          }
        }, 150)
      })
      .catch((ex) => {
        console.log(ex)
      })
  },

  renderMessage(el, message, type) {
    el.insertAdjacentHTML('beforeend', `<div class="text-center callout callout--${type}">${message}</div>`)
  },
}

export default AddToCart
